/**
 * @file Route: finishes
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

 import "layouts/main";
 import "components/Title";
 import { VisualPlus } from "components/VisualPlus"; 
import { replaceFragment } from "@olmokit/core/fragments";
import { FormType } from "components/Form";
 import "./index.scss";

console.log("Route finishes/index.js mounted.");
VisualPlus();

replaceFragment("contactForm", "components.FormType").then(() => FormType());
// FormType();